export async function getClientPing() {
  const start = performance.now();
  try {
    // await fetch("http://127.0.0.1:8000", { mode: "no-cors" });
    // await fetch("https://shirtexapi.theicthub.com", { mode: "no-cors" });
    await fetch("https://www.google.com", { mode: "no-cors" });
    const end = performance.now();
    console.log("end", end);
    console.log("start", start);
    console.log("ping", Math.round(end - start));
    return Math.round(end - start);
  } catch (err) {
    return null;
  }
}

// export async function getClientPing() {
//   const start = performance.now();
//   try {
//     await fetch("https://shirtexapi.theicthub.com/ping", { 
//       method: "HEAD", 
//       mode: "no-cors" 
//     });
//     const end = performance.now();
//     return Math.round(end - start);
//   } catch (err) {
//     return null;
//   }
// }

// export function getClientPing() {
//   if ('connection' in navigator) {
//     const connection = navigator.connection;
//     return {
//       effectiveType: connection.effectiveType, // '4g', '3g', etc.
//       downlink: connection.downlink, // Mbps
//       rtt: connection.rtt // Round-trip time in ms
//     };
//   }
//   return null;
// }

export function estimateSignalStrength(ping) {
  if (!ping) return { strength: "No connection", color: "red" };
  if (ping < 100) return { strength: "Excellent", color: "darkgreen" };
  if (ping < 300) return { strength: "Good", color: "lightgreen" };
  if (ping < 600) return { strength: "Weak", color: "orange" };
  return { strength: "Poor", color: "red" };
}
